import type { FaireProductEntity } from "../../entity_types/product";

export const p_rgcav3bu9z: FaireProductEntity = {
  token: "p_rgcav3bu9z",
  type: "product",
  name: "Feelzies SlowFlow™ Squishy Apples",
  brandToken: "b_y9hm5t29e6",
  brandName: "Feelzies",
  imageUrl:
    "https://cdn.faire.com/fastly/a240b88242645e9f78f3a075a46f1a5d2f6a0b681f274001d3a201a1b5dbb3c7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ad68b5882b778adcb79799f2c0d4e0ca17cf75332b58ef97b48376e0fc2dd8d.png",
    "https://cdn.faire.com/fastly/1a69a4d0ae99903ef4116c643e436f13e60b6a9937b653f8b6f5f66d53e66d11.png",
    "https://cdn.faire.com/fastly/5a3a8cd86837be01c1490321714ce7386d4758c7d26521dc0313d840afaf262f.png",
    "https://cdn.faire.com/fastly/b7574ac0ed51ba0f31b20b35b3c20974da466da680011d4191476dcff589b787.png",
    "https://cdn.faire.com/fastly/9d304a4807c49c705f3fa29777a2783e571c2a18e6e4f1df1223723d21dac16e.png",
    "https://cdn.faire.com/fastly/5602b9110b6c879bb5d00b1d8fba7134a1a8a16da4200e3f929688583580c908.png",
  ],
  priceDollars: 7.19,
  description:
    'Meet Feelzies SlowFlow™ Squishy Apples — soft, smooth, and seriously satisfying to squeeze.\n\nMade with our signature SlowFlow™ fill, these translucent apple squishies have the same uniquely soft sensory feel customers love from our original Feelzies bracelet collection.\n\nEach apple measures approximately 2.5 inches in diameter and is perfect for fidgeting, sensory play, desk toys, gifts, party favors, classroom rewards, and retail impulse displays.\n\nAvailable in 5 collectible translucent colors: Cherry, Granny Apple, Blue Raspberry, Pink Lemonade, and Golden Apple.\n\n * Signature SlowFlow™ fill \n * Soft, smooth, satisfying squeeze \n * Approx. 2.5" diameter \n * Translucent apple design \n * Available in 5 collectible colors \n * Great for sensory play, fidgeting, gifts, prizes, and displays ',
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:43.181Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
